import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileRefreshService {
  private refreshTopbarSource = new Subject<void>();

  refreshTopbar$ = this.refreshTopbarSource.asObservable();

  refreshTopbar() {
    this.refreshTopbarSource.next();
  }
}